// Translations for the Trainings page.
const trainingsDict = [
  { en: "Trainings & Seminars", sw: "Mafunzo & Semina" },
  { en: "Loading...", sw: "Inapakia..." },
  { en: "Register", sw: "Jisajili" },
  { en: "Download Certificate", sw: "Pakua Cheti" },
  { en: "No trainings scheduled.", sw: "Hakuna mafunzo yaliyopangwa." },
];

export default trainingsDict;
